export enum __COLORS {
  PRIMARY = "#1E7018",
  PRIMARY_GRADIENT = "#20BD15",
  SECONDARY = "#2D2370",
  WHITE = "#ffffff",
  GRAY = "#eee",
  RED = "#ff0000",
  BLACK = "#000",
  GOLD = "#FFD700",
}

export const SPACING = 8;
